// gavion.email.sequences.* — sequences list and editor (FR/EN parity is tested globally).
export const sequencesMessages = {
  fr: {
    title: "Séquences",
    new: "Nouvelle séquence",
    // GAVION X4: starter sequences
    starters: {
      install: "Installer les séquences de départ",
      hint: "Crée « Après message laissé », « Après envoi de la brochure » et « Après démo » (FR et EN), désactivées. Révisez-les, faites approuver les modèles, puis activez-les.",
      installed:
        "%{smart_count} séquence de départ installée (désactivée) |||| %{smart_count} séquences de départ installées (désactivées)",
      none: "Les séquences de départ sont déjà installées.",
      missing:
        "Modèles manquants pour : %{keys}. Installez les modèles par défaut, puis réessayez.",
    },
    empty: "Aucune séquence pour l'instant.",
    steps_count: "%{smart_count} étape |||| %{smart_count} étapes",
    active_enrollments: "Inscriptions actives : %{count}",
    // GAVION open-pixel
    stats: {
      title: "Statistiques par étape",
      list_caption: "Statistiques de %{name}",
      step: "Étape",
      step_n: "Étape %{n}",
      sent: "Envoyés",
      opened: "Ouverts",
      clicked: "Cliqués",
      replied: "Réponses",
      empty: "Aucun envoi pour l'instant.",
      unavailable: "Statistiques indisponibles.",
      auto_hint: "%{count} ouverture(s) probablement automatique(s) exclue(s)",
      opened_note:
        "Les ouvertures probablement automatiques (Apple Mail, antivirus) sont exclues des taux d'ouverture.",
    },
    enabled: "Activée",
    disabled: "Désactivée",
    fields: {
      name: "Nom de la séquence",
      description: "Description",
      enabled: "Activée",
      send_window: "Fenêtre d'envoi (heure de Toronto)",
      window_from: "De",
      window_to: "À",
      window_days: "Jours d'envoi",
      from_mode: "Expéditeur",
      from_email: "Adresse fixe",
      stop_on: "Conditions d'arrêt",
      steps: "Étapes",
    },
    days: {
      "1": "Lun",
      "2": "Mar",
      "3": "Mer",
      "4": "Jeu",
      "5": "Ven",
      "6": "Sam",
      "7": "Dim",
    },
    channels: {
      graph: "Microsoft 365 (boîte du représentant)",
      ses: "Amazon SES",
    },
    graph_note:
      "Les envois Microsoft 365 peuvent être différés tant que Microsoft 365 n'est pas connecté.",
    from_modes: {
      owner_rep: "Boîte du représentant (Microsoft 365)",
      fixed: "Adresse fixe",
    },
    stop: {
      reply: "Réponse reçue",
      unsubscribe: "Désabonnement",
      bounce: "Rebond",
      complaint: "Plainte",
      deal_stage_changed: "Changement d'étape du deal",
      do_not_call: "Ne pas appeler",
      customer: "Devenu client",
      not_interested: "Pas intéressé",
      demo_booked: "Démo réservée",
      in_pipeline: "En pipeline",
      deal_created: "Deal créé",
    },
    stop_fixed:
      "Ces conditions sont toujours actives (réponse, deal créé, gagné ou perdu, pas intéressé, démo réservée, ne pas contacter, désabonnement) et ne peuvent pas être modifiées.",
    consent: {
      required: "Consentement requis",
      exempt: "Exempté (tous les envois sont personnels/transactionnels)",
    },
    add_step: "Ajouter une étape",
    remove_step: "Retirer l'étape %{n}",
    move_up: "Monter l'étape %{n}",
    move_down: "Descendre l'étape %{n}",
    step_n: "Étape %{n}",
    step_template_n: "Modèle de l'étape %{n}",
    step_delay_n: "Délai de l'étape %{n} (jours ouvrables)",
    step_channel_n: "Canal de l'étape %{n}",
    choose_template: "Choisir un modèle",
    draft_suffix: "(brouillon, non approuvé)",
    archived_suffix: "(archivé)",
    archived_step: "Ce modèle est archivé : choisissez-en un autre.",
    // GAVION sequence-auto-enroll
    auto_enroll: {
      title: "Inscription automatique",
      hint: "Chaque jour ouvrable dès 8 h, la séquence inscrit au hasard des compagnies du segment : les vôtres et celles sans représentant (qui vous sont alors attribuées). Les exclusions de « Ajouter à la campagne » s'appliquent, et jamais plus que votre plafond Outlook du jour.",
      segment: "Segment",
      choose_segment: "Choisir un segment",
      create_segment: "Créer un segment",
      per_day: "Nombre par jour",
      active: "Active",
      paused: "En pause",
      save: "Enregistrer l'inscription automatique",
      turn_off: "Désactiver l'inscription automatique",
      saved: "Inscription automatique enregistrée.",
      turned_off: "Inscription automatique désactivée.",
      off: "L'inscription automatique est désactivée pour cette séquence.",
      owner:
        "Représentant : %{name} (ses leads et ceux sans représentant, envoyés depuis son Outlook)",
      owner_changes:
        "En enregistrant, vous remplacez %{name} : ce seront vos leads et votre Outlook.",
      paused_empty:
        "En pause : le segment n'a plus de compagnie à inscrire. Choisissez un autre segment (ou élargissez celui-ci), puis remettez « Active ».",
      status:
        "Inscrites aujourd'hui : %{today} · Restantes dans le segment : %{left} · Dernier passage : %{last}",
      never: "jamais",
      unknown: "?",
      cap_left:
        "Envois encore possibles aujourd'hui (plafond Outlook) : %{count}",
      blockers: {
        sequence_disabled:
          "La séquence est désactivée : aucune inscription automatique tant qu'elle ne l'est pas.",
        sequence_empty: "La séquence n'a aucune étape.",
        template_draft:
          "Le modèle du courriel 1 n'est pas approuvé : approuvez-le pour que l'inscription automatique démarre.",
        attachments_missing:
          "Le courriel 1 doit avoir sa pièce jointe (la vidéo) : ajoutez-la au modèle.",
        owner_inactive:
          "Le représentant de l'inscription automatique est désactivé.",
        not_connected:
          "Outlook n'est pas connecté pour le représentant : il doit connecter Microsoft 365.",
        segment_not_found: "Le segment choisi n'existe plus.",
        segment_bad_entity: "Choisissez un segment de compagnies.",
      },
    },
    not_found: "Séquence introuvable.",
    after_enrolment: "Jours ouvrables après l'inscription",
    after_previous: "Jours ouvrables après l'étape précédente",
    // GAVION sequence-opened-delay
    step_delay_opened_n:
      "Délai de l'étape %{n} si le courriel précédent est ouvert",
    after_open:
      "Jours ouvrables après l'ouverture. Vide : même délai qu'au-dessus. Les ouvertures automatiques ne comptent pas.",
    errors: {
      name_required: "Le nom de la séquence est obligatoire.",
      no_steps: "Ajoutez au moins une étape.",
      step_template_required: "Chaque étape doit avoir un modèle.",
      step_template_draft:
        "Une étape utilise un modèle non approuvé (brouillon).",
      step_template_archived: "Une étape utilise un modèle archivé.",
      enabled_invalid: "La valeur « activée » est invalide.",
      too_many_steps: "Une séquence compte au plus 50 étapes.",
      steps_save_failed:
        "La séquence a été enregistrée, mais ses étapes n'ont pas pu l'être. Vérifiez les étapes ci-dessous puis enregistrez de nouveau.",
      delay_invalid: "Le délai doit être un nombre entier de 0 à 60.",
      no_days: "Choisissez au moins un jour d'envoi.",
      bad_time: "Heure invalide.",
      from_after_to: "L'heure de début doit précéder l'heure de fin.",
      from_domain_invalid:
        "L'adresse fixe doit appartenir au domaine d'envoi configuré.",
    },
  },
  en: {
    title: "Sequences",
    new: "New sequence",
    // GAVION X4: starter sequences
    starters: {
      install: "Install starter sequences",
      hint: "Creates “After voicemail”, “After brochure sent” and “After demo” (FR and EN), disabled. Review them, have the templates approved, then enable them.",
      installed:
        "%{smart_count} starter sequence installed (disabled) |||| %{smart_count} starter sequences installed (disabled)",
      none: "The starter sequences are already installed.",
      missing:
        "Missing templates for: %{keys}. Install the default templates, then try again.",
    },
    empty: "No sequences yet.",
    steps_count: "%{smart_count} step |||| %{smart_count} steps",
    active_enrollments: "Active enrolments: %{count}",
    // GAVION open-pixel
    stats: {
      title: "Per-step statistics",
      list_caption: "Statistics for %{name}",
      step: "Step",
      step_n: "Step %{n}",
      sent: "Sent",
      opened: "Opened",
      clicked: "Clicked",
      replied: "Replies",
      empty: "Nothing sent yet.",
      unavailable: "Statistics unavailable.",
      auto_hint: "%{count} probably automatic open(s) excluded",
      opened_note:
        "Probably automatic opens (Apple Mail, security scanners) are excluded from open rates.",
    },
    enabled: "Enabled",
    disabled: "Disabled",
    fields: {
      name: "Sequence name",
      description: "Description",
      enabled: "Enabled",
      send_window: "Send window (Toronto time)",
      window_from: "From",
      window_to: "To",
      window_days: "Sending days",
      from_mode: "Sender",
      from_email: "Fixed address",
      stop_on: "Stop conditions",
      steps: "Steps",
    },
    days: {
      "1": "Mon",
      "2": "Tue",
      "3": "Wed",
      "4": "Thu",
      "5": "Fri",
      "6": "Sat",
      "7": "Sun",
    },
    channels: {
      graph: "Microsoft 365 (rep's mailbox)",
      ses: "Amazon SES",
    },
    graph_note:
      "Microsoft 365 sends may be deferred until Microsoft 365 is connected.",
    from_modes: {
      owner_rep: "Rep's mailbox (Microsoft 365)",
      fixed: "Fixed address",
    },
    stop: {
      reply: "Reply received",
      unsubscribe: "Unsubscribe",
      bounce: "Bounce",
      complaint: "Complaint",
      deal_stage_changed: "Deal stage changed",
      do_not_call: "Do not call",
      customer: "Became a customer",
      not_interested: "Not interested",
      demo_booked: "Demo booked",
      in_pipeline: "In pipeline",
      deal_created: "Deal created",
    },
    stop_fixed:
      "These conditions are always on (reply, deal created, won or lost, not interested, demo booked, do not contact, unsubscribe) and cannot be changed.",
    consent: {
      required: "Consent required",
      exempt: "Exempt (all sends are personal/transactional)",
    },
    add_step: "Add a step",
    remove_step: "Remove step %{n}",
    move_up: "Move step %{n} up",
    move_down: "Move step %{n} down",
    step_n: "Step %{n}",
    step_template_n: "Template for step %{n}",
    step_delay_n: "Delay for step %{n} (business days)",
    step_channel_n: "Channel for step %{n}",
    choose_template: "Choose a template",
    draft_suffix: "(draft, not approved)",
    archived_suffix: "(archived)",
    archived_step: "This template is archived: pick another one.",
    // GAVION sequence-auto-enroll
    auto_enroll: {
      title: "Automatic enrolment",
      hint: "Every business day from 8 a.m., the sequence enrols random leads of the segment: yours and those without a rep (then assigned to you). The exclusions of “Add to the campaign” apply, and never more than your Outlook cap for the day.",
      segment: "Segment",
      choose_segment: "Choose a segment",
      create_segment: "Create a segment",
      per_day: "Number per day",
      active: "Active",
      paused: "Paused",
      save: "Save automatic enrolment",
      turn_off: "Turn off automatic enrolment",
      saved: "Automatic enrolment saved.",
      turned_off: "Automatic enrolment turned off.",
      off: "Automatic enrolment is off for this sequence.",
      owner:
        "Rep: %{name} (their leads and those without a rep, sent from their Outlook)",
      owner_changes:
        "Saving replaces %{name}: your leads and your Outlook will be used.",
      paused_empty:
        "Paused: the segment has no lead left to enrol. Choose another segment (or widen this one), then set it back to “Active”.",
      status:
        "Enrolled today: %{today} · Left in the segment: %{left} · Last run: %{last}",
      never: "never",
      unknown: "?",
      cap_left: "Sends still possible today (Outlook cap): %{count}",
      blockers: {
        sequence_disabled:
          "The sequence is disabled: no automatic enrolment until it is enabled.",
        sequence_empty: "The sequence has no steps.",
        template_draft:
          "Email 1's template is not approved: approve it for automatic enrolment to start.",
        attachments_missing:
          "Email 1 must carry its attachment (the video): add it to the template.",
        owner_inactive: "The automatic enrolment's rep is disabled.",
        not_connected:
          "Outlook is not connected for the rep: they must connect Microsoft 365.",
        segment_not_found: "The chosen segment no longer exists.",
        segment_bad_entity: "Choose a segment of leads.",
      },
    },
    not_found: "Sequence not found.",
    after_enrolment: "Business days after enrolment",
    after_previous: "Business days after the previous step",
    // GAVION sequence-opened-delay
    step_delay_opened_n: "Delay for step %{n} if the previous email is opened",
    after_open:
      "Business days after the open. Empty: same delay as above. Automatic opens do not count.",
    errors: {
      name_required: "The sequence name is required.",
      no_steps: "Add at least one step.",
      step_template_required: "Every step needs a template.",
      step_template_draft: "A step uses an unapproved (draft) template.",
      step_template_archived: "A step uses an archived template.",
      enabled_invalid: "The enabled value is invalid.",
      too_many_steps: "A sequence has at most 50 steps.",
      steps_save_failed:
        "The sequence was saved, but its steps could not be. Check the steps below, then save again.",
      delay_invalid: "The delay must be a whole number from 0 to 60.",
      no_days: "Pick at least one sending day.",
      bad_time: "Invalid time.",
      from_after_to: "The start time must be before the end time.",
      from_domain_invalid:
        "The fixed address must use the configured sending domain.",
    },
  },
} as const;
